export default __webpack_public_path__ + "static/media/heating.d80063c7.svg";